export default __webpack_public_path__ + "static/media/Snd3.26dea995.mp3";